module.exports = __webpack_public_path__ + "img/p3.001ea732.png";